import { ref, useCoreConfig, useDayjs, useI18n, useQuery, useUserAuthClient, useUserInfo, watch } from '#imports'

export const usePreviousLoginNotice = () => {
    const { site } = useCoreConfig()
    const { t } = useI18n()
    const dayjs = useDayjs()
    const { client } = useUserAuthClient()
    const { isLoggedIn, userJustLoggedIn } = useUserInfo()

    const query = useQuery(async ({ signal }) => {
        const { data } = await client.GET('/v1/public/session-info', { signal, params: { query: { brand: site.brand } } })

        return data?.previousLogin ?? null
    }, {
        key: 'userAuth:previousLoginNotice',
        queryCache: false,
        server: false,
        lazy: true,
        enabled: () => isLoggedIn.value && !!userJustLoggedIn.value,
    })

    const notice = ref<string>()

    // Taken once per login: later layouts must not replay it from the cache.
    watch(query.data, (previousLogin) => {
        if (!previousLogin) return

        notice.value = t('core.composables.usePreviousLoginNotice.previousLogin', { date: dayjs(previousLogin).format('DD-MM-YYYY | HH:mm') })
        userJustLoggedIn.value = undefined
        query.clear()
    }, { immediate: true })

    return query.enrich({ notice })
}
